import { sleep } from 'common/utils/common.utils';
import { useCallback } from 'react';

export function useRetry() {
    const retry = useCallback(async <T>(fn: () => Promise<T>, retries = 5, delay = 1000, factor = 2) => {
        let attempt = 0;
        let result: T;
        let error;

        while (attempt < retries) {
            try {
                result = await fn();

                return result;
            } catch (e) {
                error = e;
                attempt++;
                if (attempt < retries) {
                    await sleep(delay);
                    delay *= factor;
                }
            }
        }

        throw error;
    }, []);

    return retry;
}
